<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      show-footer
      :footer-method="amount"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'D' || row.orderStatus === 'T'
              ? 'danger'
              : row.orderStatus === 'R'
              ? 'warning'
              : row.orderStatus === 'Y' ||
                row.orderStatus === 'P' ||
                row.orderStatus === 'C'
              ? 'success'
              : 'light'
          "
        >
          {{ row.v_orderStatus }}
        </el-tag>
      </template>
      <template v-slot:showTeamName="{ row }">
        {{ row.depName }}-{{ row.teamName }}
      </template>
      <template v-slot:v_qty="{ row }">
        {{ row.v_qty }}
      </template>
      <template v-slot:showSales="{ row }">
        {{ row.v_salePriceAmount }}
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import Math from '@/libs/util.math.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return 0
      var goodsQty = 0
      var priceAmount = 0
      var salePriceAmount = 0
      var netSalePriceAmount = 0
      var usdPriceAmount = 0
      var usdSalePriceAmount = 0
      var usdNetSalePriceAmount = 0
      var usdOrderProfit = 0
      this.tableData.forEach(
        (i) => (
          (goodsQty = this.add(goodsQty, i.goodsQty)),
          (priceAmount = this.add(priceAmount, i.priceAmount)),
          (salePriceAmount = this.add(salePriceAmount, i.salePriceAmount)),
          (netSalePriceAmount = this.add(
            netSalePriceAmount,
            i.netSalePriceAmount
          )),
          (usdPriceAmount = this.add(usdPriceAmount, i.usdPriceAmount)),
          (usdSalePriceAmount = this.add(
            usdSalePriceAmount,
            i.usdSalePriceAmount
          )),
          (usdNetSalePriceAmount = this.add(
            usdNetSalePriceAmount,
            i.usdNetSalePriceAmount
          )),
          (usdOrderProfit = this.add(usdOrderProfit, i.usdOrderProfit))
        )
      )
      return [
        [
          '',
          this.$l('INDEX.total') || '合计',
          '',
          '',
          '',
          '',
          '',
          goodsQty,
          priceAmount,
          '',
          salePriceAmount,
          netSalePriceAmount,
          '',
          '',
          usdPriceAmount,
          usdSalePriceAmount,
          usdNetSalePriceAmount,
          usdOrderProfit,
        ],
      ]
    },
  },
  methods: {
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'order-dashboard-detail',
        params: { ...params, pageType },
      })
    },
    add(x, y) {
      x = x || 0
      y = y || 0
      return Math.number(Math.add(Math.bignumber(x), Math.bignumber(y)))
    },
    amount() {
      return this.footerData
    },
  },
}
</script>
